
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { TicketService } from './Ticket.service';
import { ContactService } from './Contact.service';
import { ChatService } from './Chat.service';
import { PushNotificationsService } from './Notifycation.service';
import { ToastrService } from 'ngx-toastr';

declare const WebPush: any;
@Injectable()
export class SocketService {

  public no_image = 'assets/images/contact.png';
  public no_image_mail = 'assets/images/mailbox.jpg';

  public user: any = null;
  public username: any = null;
  public agentId: any = null;
  public socket: any;
  // Observable string sources
  private missionAnnouncedSource = new Subject<any>();
  private socketSource = new Subject<string>();
  public ringAudio = new Audio('assets/sounds/incoming.mp3');
  public isCallout = false;

  public isAnswered = false;

  // Observable string streams
  missionAnnounced$ = this.missionAnnouncedSource.asObservable();
  socket$ = this.socketSource.asObservable();

  constructor(
    private ticketService: TicketService,
    private contactService: ContactService,
    private chatService: ChatService,
    private toastr: ToastrService,
    private pushNotification: PushNotificationsService
  ) {
    this.initData();
    this.ringAudio.addEventListener('ended', function () {
      this.currentTime = 0;
      this.play();
    }, false);
  }

  private is_finish: boolean = true;
  public call_id: any;
  public ticket_id: any;

  // Service message commands
  announceMission(mission: string) {
    this.missionAnnouncedSource.next(mission);
  }

  initData() {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.username = localStorage.getItem('username');
    this.agentId = localStorage.getItem('agentId');
  }

  updateChatNotify(data) {
    this.missionAnnouncedSource.next({
      action: 'updateNotify',
      data: data
    })
  }

  updateChatData(data) {
    this.missionAnnouncedSource.next({
      action: 'updateChatData',
      data: data
    })
  }

  reloadLastestTicket() {
    this.missionAnnouncedSource.next({
      action: "reloadLastestTicket",
      data: {}
    });
  }

  opentab(data: any, type: string, action: string) {
    this.missionAnnouncedSource.next({
      action: 'open-tab',
      data: {
        type: type,
        action: action,
        detail: data
      }
    })
  }

  editTab(tabIndex: any, action: string) {
    this.missionAnnouncedSource.next({
      action: 'edit-tab',
      data: {
        tabIndex: tabIndex,
        action: action
      }
    })
  }

  newHandTicket() {
    this.missionAnnouncedSource.next({
      action: "newHandTicket",
      data: {}
    });
  }

  updateHandTicket(data) {
    data.action = 'hand';
    this.missionAnnouncedSource.next({
      action: "updateHandTicket",
      data: data
    })
  }

  setSocket(socket: any) {
    this.socket = socket;
    this.socketSource.next(socket);
  }


  updateMonitor(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor',
      data: data
    })
  }

  newEmail(data) {
    this.pushNotification.generateNotification([{
      title: data.emailFrom,
      content: data.emailSubject ? data.emailSubject : data.title,//'Thư mới từ ' + data.emailFrom,
      icon: this.no_image_mail
    }])
    this.missionAnnouncedSource.next({
      action: 'new-email',
      data: data
    })
  }

  newNotification(data) {
    this.pushNotification.generateNotification([{
      title: "Thông báo",
      content: data.title,
      icon: data.type == "email" ? this.no_image_mail : this.no_image
    }])
  }

  showAvailableAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'available-agent',
      data: data
    })
  }

  updateMonitorAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-agent',
      data: data
    })
  }
  updateMonitorAgentDashboard(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-agent-dashboard',
      data: data
    })
  }

  updateMonitorAllAgent(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-all-agent',
      data: data
    })
  }

  updateMonitorCall(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-call',
      data: data
    })
  }
  updateMonitorCallList(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calllist',
      data: data
    })
  }
  updateMonitorCallDetail(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calldetail',
      data: data
    })
  }
  updateMonitorCallDetailEnd(data) {
    this.missionAnnouncedSource.next({
      action: 'update-monitor-calldetail-end',
      data: data
    })
  }

  ring(username, data) {
    // this.monitor('call_ringing',data.callId, data.caller);
    localStorage.setItem('caller', data.caller);
    if (data.callType == 'CALL_INBOUND' || (data.callType == "CALL_OUTBOUND" && !this.isCallout)) {
      this.ringAudio.play();
    }
    this.isCallout = false;
    if (data.spy) {
      return;
    }
    if ((data.username == username) && this.is_finish) {
      this.is_finish = false; //ngăn không cho cuộc gọi nữa đến
      this.ticket_id = data.ticketId;
      this.call_id = data.callId;
      if (data.ticketId) {
        this.ticketService.find(data.ticketId).toPromise().then(res => {
          if (res.status == 200 && !res.error && res.data) {
            this.contactService.findInAll({ _id: res.data.requester_id }).subscribe(rs => {
              if (rs.status == 200 && !rs.error) {
                res.data['request'] = rs.data;
                let requeseter = rs.data.name ? rs.data.name : rs.data.phone ? rs.data.phone : rs.data.email;
                res.data.subject = data.callType == 'CALL_INBOUND' ? 'Cuộc gọi từ ' + requeseter : 'Cuộc gọi ra cho khách ' + requeseter;
                res.data._id = data.ticketId;
                res.data.call_id = data.callId;
                this.opentab(res.data, 'ticket', 'ring');
              }
            })
          }
        });
      } else {
        this.ticketService.findByCall(data.callId).toPromise().then(res => {
          if (res.status == 200 && !res.error && res.data) {
            this.contactService.findInAll({ _id: res.data.requester_id }).subscribe(rs => {
              if (rs.status == 200 && !rs.error) {
                res.data['request'] = rs.data;
                let requeseter = rs.data.name ? rs.data.name : rs.data.phone ? rs.data.phone : rs.data.email;
                res.data.subject = data.callType == 'CALL_INBOUND' ? 'Cuộc gọi từ ' + requeseter : 'Cuộc gọi ra cho khách ' + requeseter;
                res.data.call_id = data.callId;
                this.opentab(res.data, 'ticket', 'ring');
              }
            })
          } else {
            let phone = data.caller;
            this.contactService.findByPhone(phone).subscribe(res => {
              if (res.status == 200 && !res.error && res.data) {
                let requeseter = res.data.name ? res.data.name : res.data.phone ? res.data.phone : res.data.email;
                //da ton tai contact
                let payload = {
                  requester_id: res.data._id,
                  source: 'call',
                  source_detail: data.callType,
                  call_id: data.callId,
                  call_type: data.callType,
                  status: 1,
                  subject: data.callType == 'CALL_INBOUND' ? 'Cuộc gọi từ ' + requeseter : 'Cuộc gọi ra cho khách ' + requeseter,
                  created_at: new Date()
                }
                // if (data.callType != 'CALL_INBOUND') {
                //   payload["assign_group_id"] = this.user.group_id;
                //   payload["assign_agent_id"] = this.user._id;
                // }
                payload["assign_group_id"] = this.user.group_id;
                payload["assign_agent_id"] = this.user._id;
                this.ticketService.create(payload).subscribe(rs => {
                  rs.data.request = res.data;
                  res.data.call_id = data.callId;
                  this.opentab(rs.data, 'ticket', 'ring');
                })
                // if (data.callType == 'CALL_INBOUND') {
                //   this.pushNotification.generateNotification([{
                //     title: data.caller,
                //     content: data.caller+' đang gọi điện đến',
                //     icon: res.data.avatar || this.no_image
                //   }])
                // }
              } else {
                //chua ton tai contact co so phone nay
                let payloadContact = {
                  phone: phone,
                  name: phone,
                  source: data.callType,
                  created_at: new Date(),
                  role: 'end_user'
                }
                this.contactService.create(payloadContact).subscribe(res => {
                  if (res.status == 200 && !res.error && res.data) {
                    let payload = {
                      requester_id: res.data._id,
                      source: 'call',
                      source_detail: data.callType,
                      call_id: data.callId,
                      call_type: data.callType,
                      status: 1,
                      subject: data.callType == 'CALL_INBOUND' ? 'Cuộc gọi từ ' + phone : 'Cuộc gọi ra cho khách ' + phone,
                      created_at: new Date()
                    };
                    // if (data.callType != 'CALL_INBOUND') {
                    //   payload["assign_group_id"] = this.user.group_id;
                    //   payload["assign_agent_id"] = this.user._id;
                    // }
                    payload["assign_group_id"] = this.user.group_id;
                    payload["assign_agent_id"] = this.user._id;
                    this.ticketService.create(payload).subscribe(rs => {
                      rs.data.request = res.data;
                      res.data.call_id = data.callId;
                      this.opentab(rs.data, 'ticket', 'ring');
                    });
                    // if (data.callType == 'CALL_INBOUND') {
                    //   this.pushNotification.generateNotification([{
                    //     title: data.caller,
                    //     content: data.caller+' đang gọi điện đến',
                    //     icon: this.no_image
                    //   }])
                    // }
                  }
                })
              }
            })
          }

        })
      }
    }
  }

  execMsg(username, code, data, isVoiceActivated) {
    switch (code) {
      case environment.code.RING_AGENT_RESPOND_ID: {
        //cuộc gọi đến
        if (!isVoiceActivated) {
          break;
        }
        if (username == data.username) {
          this.ring(username, data);
          this.missionAnnouncedSource.next({
            action: 'ring',
            data: data
          });
        }
        break;
      }

      case environment.code.NEW_NOTIFICATION_ID: {
        if (!isVoiceActivated && data.type == "call") {
          break;
        }
        if (username == data.username) {
          this.newNotification(data);
        }
        break;
      }

      case environment.code.OUTCALL_ERROR_RESPONSE_ID: {
        if (!isVoiceActivated) {
          this.toastr.error('', 'Vui lòng kích hoạt thoại để thực hiện gọi ra', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right'
          });
          break;
        }
        data['finisher'] = 'agent';
        this.endCall(username, data);
        break;
      }

      case environment.code.USER_END_CALL_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        data['finisher'] = 'user';
        this.endCall(username, data);
        break;
      }

      case environment.code.AGENT_END_CALL_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        data['finisher'] = 'agent';
        //this.endCall(username, data)
        if (this.isAnswered) {
          this.endCall(username, data);
        } else {
          let ticketCallId = document.getElementById('ticketCallId').innerHTML;
          if (data.callId == ticketCallId) {
            this.endCall(username, data);
          } else {
            console.log("agentendcall set timeout " + data.callId);
            setTimeout(() => {
              this.endCall(username, data);
            }, 4500);
          }
        }
        this.isAnswered = false;
        break;
      }

      case environment.code.DIVERT_STOP_RESPONSE: {
        if (!isVoiceActivated) {
          break;
        }
        //co answer neu stop thi tat 
        //ko co anser ma shop thi hien thong bao chuyen ko thanh con
        data['finisher'] = 'agent';
        this.endCall(username, data);
        break;
      }
      case environment.code.END_CALL_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        //kết  thúc cuộc gọi  
        this.endCall(username, data);
        break;
      }

      case environment.code.AGENT_ANSWER_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.isAnswered = true;
        let ticketCallId = document.getElementById('ticketCallId').innerHTML;
        if (data.callId == ticketCallId) {
          this.answer(username, data);
        } else {
          console.log("agent answer set timeout " + data.callId);
          setTimeout(() => {
            this.answer(username, data);
          }, 4500);
        }
        break;
      }

      case environment.code.HOLD_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.hold(username, data);
        break;
      }

      case environment.code.UNHOLD_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.unHold(username, data);
        break;
      }

      case environment.code.PERFORMING_CALL_ACTION_RESPONSE_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.callOutResponseAction(username, data);
        break;
      }

      case environment.code.MUTE_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.mute(username, data);
        break;
      }
      case environment.code.UNMUTE_RESPOND_ID: {
        if (!isVoiceActivated) {
          break;
        }
        this.unMute(username, data);
        break;
      }

      case environment.code.NEW_EMAIL_RESPOND_ID: {
        this.newEmail(data);
        break;
      }
      case environment.code.SEARCH_AGENT_RESPONSE_ID: {
        this.showAvailableAgent(data);
        break;
      }
      case environment.code.SUPVERVISOR_AGENT_RESPONSE_ID: {
        this.updateMonitorAgentDashboard(data);
        break;
      }
      case environment.code.CHANGE_AGENT_STATUS_REQUEST: {
        this.updateMonitorAgent(data);
        break;
      }
      case environment.code.GET_DETAIL_AGENT_IN_QUEUE_REQUEST: {
        this.updateMonitorAllAgent(data);
        break;
      }
      case environment.code.SUPVERVISOR_CALL_RESPONSE_ID: {
        this.updateMonitorCall(data);
        break;
      }
      case environment.code.OUT_CALL_RESPONSE_ID: {
        this.isCallout = true;
        break;
      }
      // monitor call
      case environment.code.CALL_DETAIL_RESPONSE_ID: {
        if (data.ended == false) {
          this.updateMonitorCallDetail(data.data);
        } else {
          this.updateMonitorCallDetailEnd(data.callId);
        }
        break;
      }
      case environment.code.CALL_LIST_RESPONSE_ID: {
        this.updateMonitorCallList(data.data);
        break;
      }
      // call action
      case environment.code.CALL_ACTION_REQUEST_ID: {
        if (!isVoiceActivated) {
          break;
        }
        console.log(JSON.stringify(data));
        if (username == data.username) {
          if("INCALL" == data.status) {
            this.toastr.error('', 'Bạn không thể thực hiện khi đang trong cuộc gọi', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right'
            });
          }
          if("NOTFOUND" == data.status) {
            this.toastr.error('', 'Không tồn tại', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right'
            });
          }
          if("FORBIDDEN" == data.status) {
            this.toastr.error('', 'Không được phép', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right'
            });
          }
          this.missionAnnouncedSource.next({
            action: 'callaction',
            data: data
          });
        }
        break;
      }
      default: break;
    }
  }

  monitor(event, id, caller?: any): void {
    let user = JSON.parse(localStorage.getItem('User'));
    let payload = {
      event: event,
      id: id,
      tenant_id: user.tenant_id
    };
    if (caller) payload['caller'] = caller;
    this.chatService.monitor(payload);
  }

  loadAgentMonitor() {
    let data = this.standParam({});
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.GET_DETAIL_AGENT_IN_QUEUE_REQUEST;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }
  loadCallMonitor() {
    let data = this.standParam({});
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.SUPVERVISOR_CALL_RESPONSE_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }
  loadCallList() {
    let data = this.standParam({});
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.CALL_LIST_RESPONSE_ID;
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  standParam(data) {
    if (data['call_id']) {
      data['callId'] = data['call_id'];
      delete data.call_id;
    }
    // if (!this.username) {
    //   this.initData();
    // }
    this.initData();
    data['username'] = this.username;
    data['agentId'] = this.agentId;
    return data;
  }
  /**
   * Khi nhận được msg báo kết thúc cuộc gọi
   * @param username 
   * @param data 
   */
  endCall(username, data) {
    console.log("endcall");
    if (data.username == username) {
      this.is_finish = true;
      this.missionAnnouncedSource.next({
        action: 'endCall',
        data: data
      });

      // this.monitor('call_endcall',data['callId'], localStorage.getItem('caller'));
      // this.updateMonitor({
      //   event: 'call_endcall',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
    try {
      if (!this.ringAudio.paused && this.ringAudio.currentTime > 0 && !this.ringAudio.ended) {
        this.ringAudio.pause();
        this.ringAudio.currentTime = 0;
      } else {
        //Not playing...maybe paused, stopped or never played.
      }
    } catch (e) {
      console.log("ringaudio", e);
    }
  }

  activateVoice() {
    let data = this.standParam({});
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.VOICE_ACTIVATED,
      data: data
    })
  }

  answer(username, data) {
    this.ringAudio.pause();
    this.ringAudio.currentTime = 0;
    if (data.username == username) {
      this.ticketService.updateStatusCalling({
        call_id: data['callId'],
        status: 'answer'
      }).subscribe(rs => {
      })
      this.missionAnnouncedSource.next({
        action: 'answer',
        data: data
      })
      // this.monitor('call_answering',data['callId'], localStorage.getItem('caller'));
      // this.updateMonitor({
      //   event: 'call_answering',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  hold(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'hold',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId
        }
      })
      this.ticketService.updateMany({ call_id: data.callId }, { $inc: { holded_number: 1 }, is_holding: 1 }).subscribe(rs => {
        console.log('update holding for ticket');
      })
      // this.monitor('call_holding',data['callId']);
      // this.updateMonitor({
      //   event: 'call_holding',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  unHold(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'unHold',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId
        }
      })
      this.ticketService.updateMany({ call_id: data.callId }, { is_holding: 0 }).subscribe(rs => {
        console.log('update un-holding for ticket');
      })
      // this.monitor('call_unholding',data['callId']);
      // this.updateMonitor({
      //   event: 'call_unholding',
      //   id:data['callId'],
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  mute(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'mute',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId
        }
      })
    }
  }

  unMute(username, data) {
    if (data.username == username && data.status == 'OK') {
      this.missionAnnouncedSource.next({
        action: 'unMute',
        data: {
          call_id: data.callId,
          username: data.username,
          agent_id: data.agentId
        }
      })
    }
  }

  callOutResponseAction(username, data) {
    if (data.username == username && data.status == 'OK') {
      switch (data.action) {
        case 'CALL_OUT_HOLD': {
          this.hold(username, data)
          break;
        }
        case 'CALL_OUT_UNHOLD': {
          this.unHold(username, data);
          break;
        }
        case 'CALL_OUT_MUTE': {
          this.mute(username, data);
          break;
        }
        case 'CALL_OUT_UNMUTE': {
          this.unMute(username, data);
          break;
        }
        case 'TERMINATE': {
          this.endCall(username, data);
          break;
        }
        default: break;
      }
    }
  }

  showErrorDisconnect() {
    this.toastr.error('', 'Mất kết nối đến server. Vui lòng thử lại sau', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  execToOutPhone(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.DIVERT_INVITE_REQUEST
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execToACD(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.TRANSFER_TO_ACD_REQUEST_ID
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execToIVR(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.TRANSFER_TO_IVR_REQUEST_ID
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execUpdateAssignMe(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = 5000
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  execInvite(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.INVITE_REQUEST_ID
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }


  execCallOutRequestAction(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.PERFORMING_CALL_ACTION_REQUEST_ID
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }
  /**
   * Chuyển cuộc gọi cho agen khác 
   * @param data 
   */
  execForward(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.TRANSFER_AGENT_TO_AGENT_REQUEST_ID
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * xử lý tắt mở âm thanh
   * @param data 
   * @param type 
   */
  execMute(data, type) {
    data = this.standParam(data);

    let payload = {
      data: data
    }
    if (type == 'on') {
      payload['objectId'] = environment.code.UNMUTE_REQUEST_ID
    } else {
      payload['objectId'] = environment.code.MUTE_REQUEST_ID
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  /**
   * Xử lý hold hay unhold  cuộc gọi
   * @param data 
   * @param type 
   */
  execHold(data, type) {
    data = this.standParam(data);
    let payload = {
      data: data
    }
    if (type == 'on') {
      payload['objectId'] = environment.code.UN_HOLD_REQUEST_ID
    } else {
      payload['objectId'] = environment.code.HOLD_REQUEST_ID
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }
  /**
   * Xử lý chủ động kết thúc cuộc gọi
   * @param data
   */
  execEndCall(data) {
    this.ringAudio.pause();
    this.ringAudio.currentTime = 0;
    data = this.standParam(data);
    this.ticketService.updateStatusCalling({
      call_id: data['callId'],
      status: 'end_call'
    }).subscribe(rs => {
      console.log('cho chet  end_call');
    })
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.AGENT_REJECT_CALL_REQUEST_ID,
      data: data
    })
  }


  /**
   * Goi ra mot so dien thoai 
   * @param phone 
   */
  execCall(phone, ticketId: any = undefined, campaign_id: any = undefined) {
    let data = this.standParam({ telephoneNumber: phone, ticketId: ticketId });
    if (campaign_id) {
      data.campaignId = campaign_id;
    }
    let queue = localStorage.getItem('calloutDefault');
    if (queue) {
      data.queueId = queue;
    }
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.OUT_CALL_REQUEST_ID,
      data: data
    })
  }

  execRegisterUpdateAgent(agent_id, type = 0, new_agent_id?: any) {
    if (!this.socket) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.USER_PHONE_REGISTER,
      data: {
        actionType: type, //0 : register , 1: update,
        newAgentId: new_agent_id ? new_agent_id : agent_id
      }
    })
  }

  voiceSetting(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.USER_PHONE_SELECT,
      data: data
    })
  }

  changeAgentStatus(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CHANGE_AGENT_STATUS_REQUEST,
      data: data
    })
  }

  changeAgentStatusSupervisor(data) {
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CHANGE_AGENT_STATUS_REQUEST,
      data: data
    })
  }

  getAgentAvailable(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.SEARCH_AGENT_REQUEST_ID,
      data: data
    })
  }

  sendNotifyTicket(data) {
    data = this.standParam(data);
    let payload = {
      data: data
    }

    payload['objectId'] = environment.code.SEND_CHAT_MESSAGE_EVENT
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send(payload);
  }

  logout() {
    let data = this.standParam({});
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGOUT_REQUEST_ID,
      data: data
    })
  }
  // supervisor
  interact(data) {
    data = this.standParam(data);
    if (!this.socket || !data['agentId']) {
      this.showErrorDisconnect();
      return;
    }
    this.socket.send({
      objectId: environment.code.CALL_ACTION_REQUEST_ID,
      data: data
    })
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Socket.service.ts